/* Switcher de paises AR/US (variante dropdown de snippets/pais.liquid).
   Idempotente: puede cargarse varias veces (announcement bar, drawer, footer)
   y re-inicializarse en shopify:section:load sin duplicar listeners. */
(function () {
  if (window.__siteSwitcherInit) return;
  window.__siteSwitcherInit = true;

  var openSwitcher = null;

  function getToggle(switcher) {
    return switcher.querySelector('[data-site-switcher-toggle]');
  }

  function getOptions(switcher) {
    return switcher.querySelector('[data-site-switcher-options]');
  }

  function close(switcher) {
    if (!switcher) return;
    var toggle = getToggle(switcher);
    var options = getOptions(switcher);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (options) options.hidden = true;
    if (openSwitcher === switcher) openSwitcher = null;
  }

  function open(switcher) {
    if (openSwitcher && openSwitcher !== switcher) close(openSwitcher);
    var toggle = getToggle(switcher);
    var options = getOptions(switcher);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (options) options.hidden = false;
    openSwitcher = switcher;
  }

  function focusOption(switcher, index) {
    var links = switcher.querySelectorAll('[data-site-switcher-options] a');
    if (!links.length) return;
    var i = ((index % links.length) + links.length) % links.length;
    links[i].focus();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-site-switcher]').forEach(function (switcher) {
      if (switcher.dataset.initialized === 'true') return;
      var toggle = getToggle(switcher);
      var options = getOptions(switcher);
      if (!toggle || !options) return;
      switcher.dataset.initialized = 'true';

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          close(switcher);
        } else {
          open(switcher);
        }
      });

      switcher.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close(switcher);
          toggle.focus();
          return;
        }

        var links = Array.prototype.slice.call(options.querySelectorAll('a'));
        var idx = links.indexOf(document.activeElement);

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (options.hidden) open(switcher);
          focusOption(switcher, idx + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (options.hidden) open(switcher);
          focusOption(switcher, idx <= 0 ? -1 : idx - 1);
        } else if (event.key === 'Home' && !options.hidden) {
          event.preventDefault();
          focusOption(switcher, 0);
        } else if (event.key === 'End' && !options.hidden) {
          event.preventDefault();
          focusOption(switcher, -1);
        }
      });

      // Cerrar si el foco sale del componente (Tab)
      switcher.addEventListener('focusout', function (event) {
        if (!options.hidden && !switcher.contains(event.relatedTarget)) {
          close(switcher);
        }
      });
    });
  }

  // Un solo listener global para el click afuera (antes se registraba uno
  // por instancia y por re-render, sin limpieza).
  document.addEventListener('click', function (event) {
    if (openSwitcher && !openSwitcher.contains(event.target)) {
      close(openSwitcher);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
